var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4",
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c("filter-manager", {
        ref: "trainingHistoryFilterRef",
        attrs: { filters: _vm.filterManagerConfig },
        on: {
          academicYear: _vm.onChangeAcademicYear,
          activity: _vm.onChangeActivity,
          center: _vm.onChangeCenter,
          month: _vm.onChangeMonth,
          provider: _vm.onChangeProvider,
          search: _vm.onSearchHandler,
          serviceLocation: _vm.onChangeLocationService,
          specialist: _vm.onChangeSpecialist
        },
        model: {
          value: _vm.filter,
          callback: function($$v) {
            _vm.filter = $$v
          },
          expression: "filter"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultado de Adiestramiento, Taller y COMPU" }
      }),
      _vm._l(_vm.trainingResult, function(item, index) {
        return _c(
          "div",
          { key: "training-history" + index },
          [
            _c(
              "custom-callout",
              {
                staticClass: "mb-3 custom-callout",
                attrs: { "has-toggle": false }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-2 border-right" }, [
                    _c(
                      "div",
                      { staticClass: "font-weight-bold color-black font-16" },
                      [_vm._v(" " + _vm._s(item.activity) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-weight-normal color-secondary-6 font-14"
                      },
                      [_vm._v(" " + _vm._s(item.center) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col-md-8" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Fecha: ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-normal color-black font-16"
                          },
                          [_vm._v(" " + _vm._s(item.date) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Estudiante / SIE: ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-normal color-black font-16"
                          },
                          [_vm._v(" " + _vm._s(item.student.fullName) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-normal color-secondary-6 font-14"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.student.studentId == 0
                                    ? "-"
                                    : item.student.studentId
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Horario: ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-normal color-black font-16"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.timeEnd.totalMinutes == 0
                                    ? "-"
                                    : item.schedule
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Especialista: ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-normal color-black font-16"
                          },
                          [_vm._v(" " + _vm._s(item.specialist) + " ")]
                        )
                      ])
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-2 text-center" },
                    [
                      _c("drop-down", {
                        staticClass: "actions-dropdown",
                        attrs: {
                          "data-item": { item, index },
                          items: _vm.actionItems
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ],
          1
        )
      }),
      _vm.trainingResult.length == 0 ? _c("result-not-found") : _vm._e(),
      _vm.trainingResult.length > 0 &&
      _vm.pagination.totalItemCount > _vm.paginationConfig.initialPageSize
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": true },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }